export let tabHash = {};
export let tab_0;
export let tab_1;
export let default_tab_0;
export let courseusergroups;
export let courseusergroup;
export let masq_user;
export let instance;
export let instances;
export let course;
export let courses;
export let elementx;
export let elements;
export let itemversion;
export let itemversions;
export let courseuser;
export let courseunique;
export let courseusers;
export let courseinstructor;
export let courseinstructors;
export let elementitem;
export let institutioncredential;
export let institutioncredentials;
export let timeframe;
export let timeframes;
export let institution;
export let institutions;
export let assignmenttype;
export let assignmenttypes;
export let user;
export let elementheaders;
export let itemgroups;
export let itemtags;
export let itemtaggroups;
export let instancechapters;
export let instcredstatuses;
export let institutionroles;
export let metadepartments;
export let metasubjects;
export let itembanks;
export let itembanktypes;
export let itembankvisibilitytypes;
export let subjects;
export let departments;
export let logentrytypes;
export let courseinstructorroles;
export let bankelements;
export let placeholder = false;
export let host;
export let filemanager_host;
export let image_host;
export let adatypes;
export let requesttypegroups;
export let requesttypegroup;
export let requesttypes;
export let requesttype;
export let requestsubtype;
export let system;
export let rubric_labels = ['Criteria', 'Rubric Name', 'Insufficient', 'Needs Improvement', 'Approaching Proficiency', 'Proficient'];
export let institutiontypes;

export let countries_hash = {};
export let tcache = {};

export const questState = {};

const questStateSetters = {
    tabHash: (value) => { tabHash = value; },
    tab_0: (value) => { tab_0 = value; },
    tab_1: (value) => { tab_1 = value; },
    default_tab_0: (value) => { default_tab_0 = value; },
    courseusergroups: (value) => { courseusergroups = value; },
    courseusergroup: (value) => { courseusergroup = value; },
    masq_user: (value) => { masq_user = value; },
    instance: (value) => { instance = value; },
    instances: (value) => { instances = value; },
    course: (value) => { course = value; },
    courses: (value) => { courses = value; },
    elementx: (value) => { elementx = value; },
    elements: (value) => { elements = value; },
    itemversion: (value) => { itemversion = value; },
    itemversions: (value) => { itemversions = value; },
    courseuser: (value) => { courseuser = value; },
    courseunique: (value) => { courseunique = value; },
    courseusers: (value) => { courseusers = value; },
    courseinstructor: (value) => { courseinstructor = value; },
    courseinstructors: (value) => { courseinstructors = value; },
    elementitem: (value) => { elementitem = value; },
    institutioncredential: (value) => { institutioncredential = value; },
    institutioncredentials: (value) => { institutioncredentials = value; },
    timeframe: (value) => { timeframe = value; },
    timeframes: (value) => { timeframes = value; },
    institution: (value) => { institution = value; },
    institutions: (value) => { institutions = value; },
    assignmenttype: (value) => { assignmenttype = value; },
    assignmenttypes: (value) => { assignmenttypes = value; },
    user: (value) => { user = value; },
    elementheaders: (value) => { elementheaders = value; },
    itemgroups: (value) => { itemgroups = value; },
    itemtags: (value) => { itemtags = value; },
    itemtaggroups: (value) => { itemtaggroups = value; },
    instancechapters: (value) => { instancechapters = value; },
    instcredstatuses: (value) => { instcredstatuses = value; },
    institutionroles: (value) => { institutionroles = value; },
    metadepartments: (value) => { metadepartments = value; },
    metasubjects: (value) => { metasubjects = value; },
    itembanks: (value) => { itembanks = value; },
    itembanktypes: (value) => { itembanktypes = value; },
    itembankvisibilitytypes: (value) => { itembankvisibilitytypes = value; },
    subjects: (value) => { subjects = value; },
    departments: (value) => { departments = value; },
    logentrytypes: (value) => { logentrytypes = value; },
    courseinstructorroles: (value) => { courseinstructorroles = value; },
    bankelements: (value) => { bankelements = value; },
    placeholder: (value) => { placeholder = value; },
    host: (value) => { host = value; },
    filemanager_host: (value) => { filemanager_host = value; },
    image_host: (value) => { image_host = value; },
    adatypes: (value) => { adatypes = value; },
    requesttypegroups: (value) => { requesttypegroups = value; },
    requesttypegroup: (value) => { requesttypegroup = value; },
    requesttypes: (value) => { requesttypes = value; },
    requesttype: (value) => { requesttype = value; },
    requestsubtype: (value) => { requestsubtype = value; },
    system: (value) => { system = value; },
    institutiontypes: (value) => { institutiontypes = value; },
};

export function setQuestState(name, value, options = {}) {
    const { mirrorToWindow = true } = options;

    questState[name] = value;

    if (questStateSetters[name]) {
        questStateSetters[name](value);
    }

    if (mirrorToWindow) {
        window[name] = value;
    }

    return value;
}

export const learningmoduleitemtypesHash = {
    slide: 1,
    itemversion: 2,
    conditional: 3,
    random: 4,
    jump: 5,
    last: 6,
    first: 7,
    adaptive: 8
};

export const assignmenttypemodesHash = {
    web: 1,
    bubble: 2,
    manual: 3,
    clicker_test: 4,
    clicker_quiz: 5,
    review: 6,
    lmod: 7,
    worksheet: 8
};

export const itemversiontypesHash = {
    TEXOPEN: 1,
    TEXMC: 2,
    NONTEXMC: 3,
    NONTEXOPEN: 4,
    NONTEXMATCH: 5,
    MANUAL_SIMPLE: 6,
    SHORTANSWER: 8,
    CHEMFREERESPONSE: 9,
    SIMPLEDRAFT: 11,
    NONTEX_MULTIANSWER_MC: 15
};

// Global constants
export const TOLERANCETYPE_PERCENT = 1;
export const TOLERANCETYPE_ABSOLUTE = 2;
export const TOLERANCETYPE_EXACT_ID = 3;

// Accessibility: announce a message to screen readers via the live region
export function srAnnounce(message) {
    var el = document.getElementById('sr-announcer');
    if (el) {
        el.textContent = '';
        setTimeout(function () { el.textContent = message; }, 100);
    }
}

export function palette_Init(key) {
    var pal = $('#palette-' + key);

    if ($(pal).hasClass('.palInit')) {
        return;
    }
    $.each($('.part-input-' + key), function (j, inp) {
        $(inp).focus(function () {
            $(pal).removeClass('d-none');
        });
    });

    $(pal).find('.palette_button').mouseover(function () {
        $(this).addClass("palette_hover");
    });

    $(pal).find('.palette_button').mouseout(function () {
        $(this).removeClass("palette_hover");
    });

    $(pal).find('.palette_key').mousedown(function () {
        palette_pasteButton(this);
        answer_attempted = true;
    });

    $(pal).addClass('palInit');

}

export function palette_pasteButton(btn) {
    var b = btn.getAttribute('data-palette-value') || btn.id;

    var target = $(btn).closest('.instanceitempart-prompt').find(':text').first();

    switch (b) {
        case "e":
        case "inf":
        case "pi":
            $(target).selection('insert', {text: b, mode: 'before'});
            break;
        case "exp":
            $(target).selection('insert', {text: "(", mode: 'before'});
            $(target).selection('insert', {text: " )^(  )", mode: 'after'});
            break;
        case "frac":
            $(target).selection('insert', {text: "(", mode: 'before'});
            $(target).selection('insert', {text: " )/(  )", mode: 'after'});
            break;
        default:
            $(target).selection('insert', {text: b + "(", mode: 'before'});
            $(target).selection('insert', {text: " )", mode: 'after'});
            break;
    }
}

export function initHosts() {
    image_host = "https://quest.cns.utexas.edu:82";
    host = "https://quest.cns.utexas.edu";
    //filemanager_host = "https://quest.cns.utexas.edu";

    if (location.hostname != '127.0.0.1') {
        document.domain = 'utexas.edu';
    }

    if (document.location.href.indexOf('dev') != -1) {
        host = "https://qwebdev.cns.utexas.edu";
        //filemanager_host = "https://qwebdev.cns.utexas.edu:82";
        image_host = "https://qwebdev.cns.utexas.edu:82";
    }


    if (document.location.href.indexOf('qadmin') != -1) {
        host = "https://qadmin.cns.utexas.edu";
        filemanager_host = "https://qadmin.cns.utexas.edu";
        image_host = "https://qadmin.cns.utexas.edu:82";
    }
}

export function feedback(elem) {
    var target = $(elem).closest('.fb');

    if (!target) {
        return;
    }

    var bg = target.css('backgroundColor');
    target.css('backgroundColor', 'green');

    target.animate({backgroundColor: bg}, 1000, function () {

    });

    toggleSpinner(elem);
}

export function toggleSpinner(elem) {
    $(elem).closest('.fb').find('.spinning').toggleClass('d-none');
}

export function getTemplate(path) {
    if (!path) {
        return $.Deferred().resolve().promise();
    }

    return $.get('/assets/' + path, function (result) {
        $('html').append(result);
    }).fail(function (jqXHR, textStatus, errorThrown) {
        var msg = 'Quest template load failed: ' + path + ' ' + textStatus + ' ' + errorThrown;
        console.error(msg, jqXHR);

        if (typeof createBrowserevent === 'function') {
            createBrowserevent(
                msg,
                1,
                {status: jqXHR?.status, response: jqXHR?.responseText?.substring(0, 300)},
                'quest/getTemplate'
            );
        }

        return $.Deferred().resolve().promise();
    }).then(function () {
        return $.Deferred().resolve().promise();
    });
}

export function markCourseusermessageViewed(data) {
    return patchCall(data, null, '/courseusermessages/viewed')
}

export function markMessageViewed(data) {
    return patchCall(data, null, '/messages/viewed')
}

export function showNotification(title, created_at, message, closeFunction, closeData, noFade, popup) {
    if (popup) {
        message = message.replaceAll(new RegExp('\r?\n', 'g'), '<br>');
        confirm(message);

        if (closeFunction == null) {
            return;
        }

        return closeFunction(closeData);
    }

    if (title != null) {
        title = title.replaceAll(new RegExp('\r?\n', 'g'), '<br>');
    }

    if (message != null) {
        message = message.replaceAll(new RegExp('\r?\n', 'g'), '<br>');
    }

    var m = (created_at == null) ? message : created_at + "<br>" + message;
    var closeClick = function () {
        console.log("closed")
    };

    if (closeFunction != null) {
        closeClick = function () {
            return closeFunction(closeData);
        }
    }

    var timeOut = 0;
    var extendedTimeOout = 0;
    if (!noFade) {
        timeOut = 10000;
        extendedTimeOout = 20000;
    }

    toastr.info(m, title, {
        timeOut: timeOut,
        closeButton: true,
        extendedTimeOut: extendedTimeOout,
        onHidden: closeClick,
        data: {},
        enableHtml: true
    })
}

export let last_courseusermessage_id = 0;

export function updateCourseusermessagesDisplay(cu) {
    var arr = [];

    var data = {
        courseuser: cu.id,
        courseuser_courseunique: true,
        courseunique_course: true,
        floor_id: last_courseusermessage_id
    }

    return $.when(
        seedCourseusermessages(data, arr)
    ).then(
        function (data) {
            var messages = arr[0];

            messages.forEach(
                function f(m) {
                    showNotification(m.courseuser.courseunique.course.name, m.created_at, m.message, markCourseusermessageViewed, {courseusermessage: m.id}, true)
                }
            )

            if (messages.length > 0) {
                last_courseusermessage_id = messages[messages.length - 1].id;
            }

            return true;
        }
    )
}

export let last_message_t = 0;

export function updateNotificationDisplay() {
    var arr = [];

    var data = {dt: last_message_t}

    return $.when(
        seedMessages(data, arr)
    ).then(
        function (data) {
            var messages = arr[0];

            messages.forEach(
                function f(m) {
                    var v;
                    var d;

                    if (m.cls == 'Message') {
                        v = markMessageViewed;
                        d = {message: m.id};

                        if (m.popup) {
                            d['popup'] = true;
                        }
                    }

                    showNotification("", m.created_at_short, m.output_for_view, v, d, m.confirm_to_close, m.popup);
                }
            )

            if (messages.length > 0) {
                last_message_t = messages[messages.length - 1].created_at_f;
            }

            return true;
        }
    )
}

export function displayBulletins() {
    var arr = [];

    $('#bulletins-card-div').html('');

    return $.when(
        seedBulletins({}, arr)
    ).then(
        function (d) {
            var messages = arr[0];

            $('#user-bulletins-div').toggleClass('d-none', (messages.length == 0));

            messages.forEach(
                function (b) {
                    var s = (b.title ? b.title : 'Quest');

                    showBulletin(s, b.created_at, b.output_for_view)
                }
            )
        }
    )
}

export function showBulletin(sender, created_at, message) {
    $('#bulletins-card-div').append(
        $.templates('#user-bulletin-template').render({
            sender: sender,
            created_at: created_at,
            message: message,
            controller: window.controller
        })
    )
}

export function seedMessages(data, arr) {
    return getCall(data, arr, '/messages/index', null, true)
}

export function seedCourseusermessages(data, arr) {
    return getCall(data, arr, '/courseusermessages/index')
}

export function seedCourseuser(data, arr) {
    return getCall(data, arr, '/courseusers/show', 'courseuser')
}

export function seedCourseusergroup(data, arr) {
    return getCall(data, arr, '/courseusergroups/show', 'courseusergroup')
}

export function seedCourseusergroups(data, arr) {
    return getCall(data, arr, '/courseusergroups/index', 'courseusergroups')
}

export function seedCourseusers(data, arr) {
    return getCall(data, arr, '/courseusers/index', 'courseusers')
}

export function seedInstitutions(data, arr) {
    return getCall(data, arr, '/institutions/index', 'institutions')
}

export function seedMetainstitutions(data, arr) {
    return getCall(data, arr, '/metainstitutions/index', 'metainstitutions')
}

export function seedPendingCourseusers(data, arr) {
    return getCall(data, arr, '/courseusers/pending')
}

export function seedAssignmenttypes(data, arr) {
    return getCall(data, arr, '/assignmenttypes/index', 'assignmenttypes')
}

export function seedInstancechapters(data, arr) {
    return getCall(data, arr, '/instancechapters/index', 'instancechapters')
}

export function seedAssignmenttype(data, arr) {
    return getCall(data, arr, '/assignmenttypes/show', 'assignmenttype')
}

export function seedCourse(data, arr, options = {}) {
    return getCall(data, arr, '/courses/show', (options.localOnly ? null : 'course'))
}

export function seedInstitution(data, arr) {
    return getCall(data, arr, '/institutions/show', 'institution')
}

export function seedElements(data, arr) {
    return getCall(data, arr, '/elements/index', 'elements')
}

export function seedElement(data, arr, options = {}) {
    return getCall(data, arr, '/elements/show', (options.localOnly ? null : 'elementx'))
}

export function seedItemtags(data, arr) {
    return getCall(data, arr, '/itemtags/index', 'itemtags')
}

export function seedElementheaderelems(data, arr) {
    return getCall(data, arr, '/elementheaderelems/index')
}

export function seedElementheaders(data, arr) {
    return getCall(data, arr, '/elementheaders/index', 'elementheaders')
}

export function seedInstances(data, arr) {
    return getCall(data, arr, '/instances/index', 'instances')
}

export function seedCourses(data, arr) {
    return getCall(data, arr, '/courses/index', 'courses')
}

export function seedInstance(data, arr) {
    return getCall(data, arr, '/instances/show', 'instance')
}

export function seedSystemItemtaggroups(data, arr) {
    return getCall(data, arr, '/itemtaggroups/system', 'itemtaggroups')
}

export function seedTimeframes(data, arr) {
    return getCall(data, arr, '/timeframes/index', 'timeframes')
}

export function updateEnrolled(data) {
    return patchCall(data, null, '/courseusers/enroll');
}

export function seedItemtaggroups(data, arr) {
    return getCall(data, arr, '/itemtaggroups/index', 'itemtaggroups')
}

export function deleteCustomreview(data) {
    return deleteCall(data, null, '/customreviews/destroy');
}

export function createCustomreview(data) {
    return postCall(data, null, '/customreviews/create');
}

export function seedItemkeys(data, arr) {
    return getCall(data, arr, '/itemkeys/index')
}

export function createContact(data) {
    return postCall(data, null, '/contact/create');
}

export function callPulse() {
    return getCall({}, null, '/instances/pulse')
}

export function doUpdateProfileUser(elem) {
    var data = $(elem).closest('.user-bound').find('select, input, textarea').serialize();

    //need to build manually because the datatable screws up serialization of the hidden field

    return $.when(
        updateProfileUser(data)
    ).then(
        function (d) {
            feedback(elem);
        }
    )
}

export function seedProfileUser(data, arr) {
    return getCall(data, arr, '/profiles/show_user')
}

export function updateProfileUser(data) {
    return $.when(
        patchCall(data, null, '/profiles/update_user')
    ).then(
        function (d) {

        }
    )
}

export function seedDevFooter(data, arr) {
    return getCall(data, arr, '/main/dev_footer')
}

export function doCreateLegal(elem) {
    $(elem).prop('disabled', true);

    return $.when(
        createLegal({})
    ).then(
        function (d) {
            alert("You agreed to the terms of service.  Thanks!");

            window.location.href = controller_path + '/home/index';
        }
    )
}

export function createLegal(data) {
    return postCall(data, null, '/legal/create');
}

export function seedTable(data, fn, parent, row_template, render_hash, render_var, page, arr, row_f) {
    if (page == 0) {
        if (arr) {
            arr[0] = [];
        }

        var id = $(parent).attr('id');
        id = id + "_processing";
        $('#' + id).css('top', '50px');
        $('#' + id).show();
    }

    var records = [];

    data.page = page;

    return $.when(
        fn(data, records)
    ).then(
        function (d) {
            if (Array.isArray(records) && records[0] && !Array.isArray(records[0])) { //handle case where returned data isn't an array
                records[0] = [records[0]];
            }
            records = records[0];

            if (records.length == 0) {
                return;
            }

            if (arr) {
                arr[0] = arr[0].concat(records);
            }

            if (processRecordsAsRows(parent, records, row_template, render_hash, render_var, row_f) == -1) {
                return;
            }

            return seedTable(data, fn, parent, row_template, render_hash, render_var, page + 1, arr, row_f);
        }
    ).always(
        function (d) {
            if (page == 0) {
                if ($(parent).hasClass('table')) {
                    $(parent).DataTable().draw(true);
                }

                var i = $(parent).attr('id');
                i = i + "_processing";
                $('#' + i).hide();
            }
        }
    )
}

export function processRecordsAsRows(parent, records, row_template, render_hash, render_var, row_f) {
    records.forEach(
        function f(record) {
            render_hash[render_var] = record;

            var helpers = {quoter: cleanupString};

            var rows = $.templates(row_template).render(render_hash, helpers);

            var spl = rows.match(/<tr/g);
            var count = (spl || []).length;
            var new_rows = [];

            if (count > 1) {
                rows.split("<tr").forEach(function (r) {
                    if (r.trim().length > 0) {
                        var s = "<tr" + r;
                        new_rows.push(s);
                    }
                })
            } else {
                new_rows.push(rows);
            }

            new_rows.forEach(function (r) {
                    var row = $(r);

                    var new_row;

                    if ($(parent).hasClass('table')) {
                        if (!row.is('tr')) {
                            return -1;
                        }

                        new_row = $(parent).DataTable().row.add(row);
                    } else {
                        new_row = $(parent).append(row);
                    }

                }
            )
        }
    )

    if ($(parent).hasClass('table')) {
        $(parent).DataTable().draw(true);
    }

    if (row_f != null) {
        row_f(parent, records)
    }
}

export function makeCall(data, arr, path, var_name, type, skip_timer, absolute) {
    const now = new Date();
    const timeoutInMs = (timeoutMinutes - 1) * 60 * 1000;

    if (!skip_timer && (now - lastConnect > timeoutInMs)) {
        window.location.reload();
        return;
    }

    lastConnect = now;

    if (path[0] == '/') {
        path = path.replace('/', '')
    }

    return $.ajax({
            url: (absolute ? '/' : controller_path) + path,
            type: type,
            data: data,
        }
    ).done(function (d) {
            if (arr) {
                arr[0] = d;
            }

            if (var_name) {
                setQuestState(var_name, d);
            }
        }
    ).fail(function (d, textStatus, errorThrown) {
            //CORS
            if (d.status === 0 && errorThrown === '') {
                window.location.reload();
                return;
            }

            if (d.status == '401') {
                window.location.reload();
                return;
            }

            if (d.status == '410') {
                handleNoAccess(d.responseText);
            } else if (d.status == '409') {
                alert(d.responseText);
            } else {
                return $.when(
                    reportHttpIssue(data, path, d.status, d.responseText.substring(0, 300))
                ).then(
                    function (d) {
                        return $.Deferred().reject(d, status);
                    }
                )
            }
        }
    )
}

export function deleteCall(data, arr, path, var_name, absolute) {
    return $.when(
        makeCall(data, arr, path, var_name, 'delete', undefined, absolute)
    ).then(
        function (d) {
            processQmessage(d);

            updateNotificationDisplay();
            return d;
        }
    )
}

export function patchCall(data, arr, path, var_name, absolute) {
    return $.when(
        makeCall(data, arr, path, var_name, 'patch', undefined, absolute)
    ).then(
        function (d) {
            processQmessage(d);

            updateNotificationDisplay();
            return d;
        }
    )
}

export let reload = false;

export function processQmessage(d) {
    if (d.qmessage) {
        if (!reload && (d.qmessage == 'RELOAD')) {
            reload = true;
            window.location.reload();
            return;
        }

        let date = moment().format("MM/DD/YY HH:MM a");
        showNotification("", date, d.qmessage, null, null, false);
    }
}

export function postCall(data, arr, path, var_name, absolute) {
    return $.when(
        makeCall(data, arr, path, var_name, 'post', undefined, absolute)
    ).then(
        function (d) {
            processQmessage(d);

            updateNotificationDisplay();
            return d;
        }
    )
}

export function getCall(data, arr, path, var_name, skip_timer, absolute) {
    return $.when(
        makeCall(data, arr, path, var_name, 'get', skip_timer, absolute)
    ).then(
        function (d) {
            processQmessage(d);
            return d;
        }
    )
}

export function reportHttpIssue(data, path, status, msg) {
    var m = "status: " + status + "\n" + msg;
    $.when(
        createBrowserevent(m, 1, data, path)
    ).then(
        function () {

        }
    )
}

export let noAccessFlag = false;

export function handleNoAccess(str) {
    if (noAccessFlag) {
        return;
    }

    noAccessFlag = true;

    alert(str);

    window.location.href = controller_path + "/courses/show?course=" + window.course.id;
}


// main function bundle for when slide is loaded or changed
export function bundlerFcn() {
    //console.log('bundled');
    handleSvg();

    $(document).keydown(function (e) {
        if (e.keyCode == 37 || (e.keyCode == 39)) {
            handleSvg();
        }
    });
}

// Accessibility: manage aria-selected on tab activation and add keyboard navigation
export function initTabAccessibility() {
    $('[role="tablist"]').each(function () {
        var tablist = $(this);
        var tabs = tablist.find('[role="tab"]');

        tabs.on('click', function () {
            tabs.attr('aria-selected', 'false').attr('tabindex', '-1');
            $(this).attr('aria-selected', 'true').attr('tabindex', '0');
            // Move focus to the associated tab panel
            var panelId = $(this).attr('aria-controls') || $(this).attr('href').replace('#', '');
            var panel = document.getElementById(panelId);
            if (panel) {
                panel.setAttribute('tabindex', '-1');
                setTimeout(function () { panel.focus(); }, 200);
            }
        });

        tabs.on('keydown', function (e) {
            var index = tabs.index(this);
            var newIndex;
            if (e.which === 39) { // right arrow
                newIndex = (index + 1) % tabs.length;
            } else if (e.which === 37) { // left arrow
                newIndex = (index - 1 + tabs.length) % tabs.length;
            } else if (e.which === 36) { // home
                newIndex = 0;
            } else if (e.which === 35) { // end
                newIndex = tabs.length - 1;
            } else {
                return;
            }
            e.preventDefault();
            tabs.eq(newIndex).focus().click();
        });

        // Set initial tabindex: active tab 0, others -1
        tabs.attr('tabindex', '-1');
        tabs.filter('[aria-selected="true"]').attr('tabindex', '0');
        tabs.filter('.active').attr('aria-selected', 'true').attr('tabindex', '0');
    });
}

export function tabUrl(elem, idx) {
    var v = $(elem).attr('id');

    if (!idx) {
        idx = 0;
    }

    var k = 'tab_' + idx;

    updateUrl(k, v);

    if (v in tabHash) {
        return true;
    }

    tabHash[v] = true;

    return false;
}

export function getUrlParam(key) {
    var string = window.location.search;
    var urlParams = new URLSearchParams(string);
    return urlParams.get(key);
}

export function updateUrl(key, val) {
    var qs = window.location.search;
    var params = new URLSearchParams(qs);
    params.set(key, val);

    history.pushState(
        {},
        'Quest ',
        window.location.origin + window.location.pathname + "?" + params
    )
}

export function createCourseusermessage(data) {
    return $.when(
        postCall(data, null, '/courseusermessages/create')
    )
}

export function seedBulletins(data, arr) {
    return getCall(data, arr, '/bulletins/index')
}

export function displayCourseusermessagesLoop(cu) {
    return $.when(
        updateCourseusermessagesDisplay(cu)
    ).then(
        function (d) {
            if (!d) {
                return;
            }
            setTimeout(function () {
                displayCourseusermessagesLoop(cu)
            }, notificationDelay);
        }
    )
}

export function DisplayNotificationsLoop() {
    return $.when(
        updateNotificationDisplay()
    ).done(
        function (d) {
            if (!d) {
                return;
            }

            setTimeout(function () {
                DisplayNotificationsLoop();
            }, notificationDelay);
        }
    )
}

export function seedPages(data, fn, page, arr) {
    if (page == 0) {
        if (arr) {
            arr[0] = [];
        }
    }

    var records = [];

    data.page = page;

    return $.when(
        fn(data, records)
    ).then(
        function () {
            records = records[0];

            if (records.length == 0) {
                return;
            }

            if (arr) {
                arr[0] = arr[0].concat(records);
            }

            return seedPages(data, fn, page + 1, arr);
        }
    ).always(
        function () {

        }
    )
}

export function createBrowserevent(msg, type_id, data, call_path) {
    if (!logBrowserevent) {
        return;
    }

    // don't run it through postCall
    var be = {
        message: msg,
        browsereventtype_id: type_id,
        data: data,
        call_path: call_path,
        current_path: window.location.pathname,
        query_string: window.location.search
    };

    return $.ajax({
            url: controller_path + '/browserevents/create',
            type: 'post',
            data: {browserevent: be}
        }
    )
}

export function cleanupString(str) {
    str = str.replace(/'/, "\\'");
    str = str.replace(/"/, '\\"');

    return str;
}

export function seedExpiredInstitutioncredentials(data, arr) {
    return getCall(data, arr, '/institutioncredentials/expired')
}

export function doSeedLikertscale(likertscale_id, arr) {
    let data = {likertscale: likertscale_id};

    return $.when(
        seedLikertscale(data, arr)
    ).then(
        function () {
            return arr;
        }
    )
}

export function seedLikertscale(data, arr) {
    return getCall(data, arr, '/likertscales/show')
}

export function doUpdateLikertFeedback(elem) {
    var data = $(elem).closest('.likertscale-bound').find('select, input, textarea').serialize();

    return $.when(
        updateLikertFeedback(data)
    ).then(
        function (d) {

        }
    )
}

export function updateLikertFeedback(data) {
    return patchCall(data, null, '/presentationitems/likertfeedback')
}

export function filterRequesttype(elem) {
    window.requesttype = window.requesttypes.find((el) => el.id == $(elem).val())

    $('#requestsubtype_div').html($.templates('#contact-requestsubtype-div-template').render(
            {
                requestsubtypes: (window.requesttype ? window.requesttype.requestsubtypes : []),
            }
        )
    )
}

export function contactSelectRequestsubtype(elem) {
    window.requestsubtype = window.requesttype.requestsubtypes.find((el) => el.id == $(elem).val())
    $('#contact-feedback').html($.templates('#contact-requestsubtype-feedback-template').render(
            {
                requestsubtype: window.requestsubtype,
            }
        )
    )
}


export function seedRequesttypegroups(data, arr) {
    return getCall(data, arr, '/requesttypegroups/index', 'requesttypegroups')
}

export function seedSortedRequesttypes(data, arr) {
    return getCall(data, arr, '/requesttypes/sorted', 'requesttypes')
}


export let tiny_mce = false;

export function initTinymce() {
    if (tiny_mce) {
        return;
    }

    tiny_mce = true;

    tinymce.init({
        selector: '.tinymce',
        plugins: "searchreplace visualblocks visualchars charmap directionality media lists link image table code help wordcount advlist autolink nonbreaking fullscreen",
        toolbar: 'cut copy paste pastetext | undo redo | searchreplace | selectall | link unlink anchor | ' +
            'image| table | hr| charmap  |fullscreen | code | preview print | ' +
            'bold italic underline strikethrough subscript superscript | removeformat |' +
            'numlist bullist | outdent indent | blockquote |alignleft aligncenter alignright alignjustify |' +
            'blocks fontfamily fontsize | forecolor backcolor|help |',
        toolbar_sticky: true,
        autosave_restore_when_empty: true,
        images_upload_handler: resource_upload_handler,
        convert_urls: true,
        file_picker_types: 'file image media',
        promotion: false,
        license_key: 'gpl',
        images_upload_credentials: true
    });

}

export const resource_upload_handler = (blobInfo, progress) => new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open('POST', "/" + window.controller + "/resources/create");

    xhr.upload.onprogress = (e) => {
        progress(e.loaded / e.total * 100);
    };

    xhr.onload = () => {
        if (xhr.status === 403) {
            reject({message: 'HTTP Error: ' + xhr.status, remove: true});
            return;
        }

        if (xhr.status < 200 || xhr.status >= 300) {
            reject('HTTP Error: ' + xhr.status);
            return;
        }

        const json = JSON.parse(xhr.responseText);

        if (!json || typeof json.location != 'string') {
            reject('Invalid JSON: ' + xhr.responseText);
            return;
        }

        resolve(json.location);
    };

    xhr.onerror = () => {
        reject('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
    };

    const formData = new FormData();
    formData.append('file', blobInfo.blob(), blobInfo.filename());
    formData.set('course', window.course.id);
    xhr.send(formData);
});

// Expose all exported functions and variables on window for inline view scripts
Object.assign(window, {
    // Global data variables
    tabHash,
    tab_0,
    tab_1,
    default_tab_0,
    courseusergroups,
    courseusergroup,
    masq_user,
    instance,
    instances,
    course,
    courses,
    elementx,
    elements,
    itemversion,
    itemversions,
    courseuser,
    courseunique,
    courseusers,
    courseinstructor,
    courseinstructors,
    elementitem,
    institutioncredential,
    institutioncredentials,
    timeframe,
    timeframes,
    institution,
    institutions,
    assignmenttype,
    assignmenttypes,
    user,
    elementheaders,
    itemgroups,
    itemtags,
    itemtaggroups,
    instancechapters,
    instcredstatuses,
    institutionroles,
    metadepartments,
    metasubjects,
    itembanks,
    itembanktypes,
    itembankvisibilitytypes,
    subjects,
    departments,
    logentrytypes,
    courseinstructorroles,
    bankelements,
    placeholder,
    host,
    filemanager_host,
    image_host,
    adatypes,
    requesttypegroups,
    requesttypegroup,
    requesttypes,
    requesttype,
    requestsubtype,
    system,
    rubric_labels,
    institutiontypes,
    countries_hash,
    tcache,

    // Hash constants
    learningmoduleitemtypesHash,
    assignmenttypemodesHash,
    itemversiontypesHash,

    // Tolerance constants
    TOLERANCETYPE_PERCENT,
    TOLERANCETYPE_ABSOLUTE,
    TOLERANCETYPE_EXACT_ID,

    // Module-level variables
    last_courseusermessage_id,
    last_message_t,
    noAccessFlag,
    reload,
    tiny_mce,
    resource_upload_handler,

    // Template and data loading
    getTemplate,
    seedTable,
    processRecordsAsRows,

    // REST API calls
    getCall,
    postCall,
    patchCall,
    deleteCall,
    makeCall,
    reportHttpIssue,

    // Seed functions (data fetching)
    seedAssignmenttype,
    seedAssignmenttypes,
    seedBulletins,
    seedCourse,
    seedCourses,
    seedCourseuser,
    seedCourseusergroup,
    seedCourseusergroups,
    seedCourseusermessages,
    seedCourseusers,
    seedDevFooter,
    seedElement,
    seedElementheaderelems,
    seedElementheaders,
    seedElements,
    seedExpiredInstitutioncredentials,
    seedInstance,
    seedInstancechapters,
    seedInstances,
    seedInstitution,
    seedInstitutions,
    seedItemkeys,
    seedItemtaggroups,
    seedItemtags,
    seedLikertscale,
    seedMessages,
    seedMetainstitutions,
    seedPages,
    seedPendingCourseusers,
    seedProfileUser,
    seedRequesttypegroups,
    seedSortedRequesttypes,
    seedSystemItemtaggroups,
    seedTimeframes,

    // Display and notification
    displayBulletins,
    displayCourseusermessagesLoop,
    DisplayNotificationsLoop,
    showBulletin,
    showNotification,
    updateCourseusermessagesDisplay,
    updateNotificationDisplay,

    // Create functions
    createBrowserevent,
    createContact,
    createCourseusermessage,
    createCustomreview,
    createLegal,

    // Update functions
    updateUrl,
    updateEnrolled,
    updateLikertFeedback,
    updateProfileUser,

    // Utility functions
    tabUrl,
    feedback,
    toggleSpinner,
    getUrlParam,
    handleNoAccess,
    initHosts,
    initTinymce,
    processQmessage,
    cleanupString,
    bundlerFcn,

    // Accessibility functions
    srAnnounce,
    initTabAccessibility,

    // Palette functions
    palette_Init,
    palette_pasteButton,

    // Misc action functions
    callPulse,
    contactSelectRequestsubtype,
    deleteCustomreview,
    doCreateLegal,
    doSeedLikertscale,
    doUpdateLikertFeedback,
    doUpdateProfileUser,
    filterRequesttype,
    markCourseusermessageViewed,
    markMessageViewed,
});

